module.exports = __webpack_public_path__ + "static/home-dome-a18bedb0366369483c2dd53b072567dd.jpg";